








































import { Component, Vue} from 'vue-property-decorator'
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
@Component({
    name:'contractOutsideDetailMoney'
})
export default class ContractOutsideDetailMoney extends AbpBase  {
    initData:any = {
        id: null,
        receivables: {
            contract: {}
        },
        tableTitle: [
            {
                title: '付款日期',
                key: 'amountDt',
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('div', [
                        params.row.amountDt.replace('T', ' ').replace('Z', '')
                    ])
                }
            },
            {
                title: '付款金额',
                key: 'amount',
                align: 'center'
            },
            {
                title: '备注',
                key: 'remark',
                align: 'center'
            },
            {
                title: '操作',
                key: 'action',
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.Edit(params.row);
                                }
                            }
                        }, '编辑')
                    ]);
                }
            }
        ],
        tableLoading: true,
        modalData: {
            isShow: false
        }
    }
    //显示弹窗
    async AddContractMoney() {
        this.initData.modalData.isShow = true;
        this.initData.submitType = 'add';
    }
    //提交合同付款与资质管理费计提
    async CreateContractReceipt() {
        this.initData.modalData.contractId = this.initData.id;
        if(this.initData.submitType == 'add'){
            await Ajax.post('/api/services/app/Contract/CreateExternalReceiptAsync', this.initData.modalData).then(()=>{
                this.$Message.success('填报成功!');
                this.GetData();
            })
        }else{
            await Ajax.put('/api/services/app/Contract/UpdateExternalReceiptAsync', this.initData.modalData).then(()=>{
                this.$Message.success('修改成功!');
                this.GetData();
            })
        }
    }

    //获取付款数据
    async GetData() {
        this.initData.receivables = (await Ajax.get('/api/services/app/Contract/GetAllExternalReceiptAsync?ContractId=' + this.initData.id)).data.result;
        this.initData.tableLoading = false;
    }
    //详情切换
    SwitchContractOutsideDetail(name:any) {
        this.$router.push({
            name: name,
            query: {id: this.initData.id}
        });
    }
    //编辑
    async Edit(data:any) {
        this.initData.modalData.isShow = true
        this.initData.modalData.amount = data.amount;
        this.initData.modalData.amountDt = data.amountDt;
        this.initData.modalData.remark = data.remark;
        this.initData.modalData.id = data.id;
        this.initData.submitType = 'edit';
    }

    async mounted() {
        this.initData.id = this.$route.query.id;
        this.initData.contractName = this.$route.query.contractName;
        this.GetData();
        //处理用户数据回调慢问题
        if(!this.$store.state.session.user){
            await this.$store.dispatch({type: 'session/init'});
        }
        this.initData.userName = this.$store.state.session.user.name;
        this.initData.organization = this.$store.state.session.user.organization.displayName;
    }
}
